<template>
    <v-container style="max-width: 1240px" class="pb-5 pt-5">
        <v-content>
            <v-layout v-if="companiesList.length" class="pt-5">
                <v-flex>
                    <h2>Заявка одобрена</h2>
                    <p>Вы будете направлены на платежную страницу страховой, после чего полис отправится на почту, и
                        будет сохранен в Личном кабинете.</p>
                </v-flex>
            </v-layout>

            <v-layout
                v-for="(company, index) in companiesList" :key="index"
                wrap row align-center
                style="padding: 36px 0; border-bottom: 1px solid rgba(0, 0, 0, 0.2); border-top: 1px solid rgba(0, 0, 0, 0.2);"
            >
                <v-flex lg3 md3 xs8 sm3 pt-3 class="antimite-list__logo">
                    <img
                        :src="'/img/partners/' + company.company_alias + '.svg'"
                        :alt="company.company_alias"
                        class="logo"
                    />
                    <br>
                    <div class="antimite-list__logo__text">
                        <p v-if="company.info && company.info.policy_name">
                            {{ company.info.policy_name }}
                        </p>
                    </div>
                </v-flex>
                <v-flex lg6 md6 sm8 pt-3 offset-xs1 xs3 offset-sm0 class="antimite-list__data">
                    <v-layout row wrap>
                        <v-flex lg4 sm5 md5 class="antimite-list__data__item hidden-xs-only" v-if="showCommission">
                            <a v-show="!commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black tip-icon width-auto"
                               data-tippy-animateFill="false"
                               data-tippy-animation="scale"
                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                            >
                                <label>Вознаграждение, Р</label>
                                <p v-if="userType && userType === 'operator'">
                                    {{ company.operator_fee_value > 0 ? Number(company.operator_fee_value).toFixed(0) : '-' }}
                                </p>
                                <p v-else>
                                    {{ company.agent_fee_value > 0 ? Number(company.agent_fee_value).toFixed(0) : '-' }}
                                </p>
                            </a>
                        </v-flex>
                        <v-flex lg4 sm5 md5 class="antimite-list__data__item hidden-xs-only" v-if="showCommission">
                            <a v-show="!commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black tip-icon width-auto"
                               data-tippy-animateFill="false"
                               data-tippy-animation="scale"
                               data-tippy-content="Нажмите, чтобы скрыть вознаграждение"
                            >
                                <label>Вознаграждение, %</label>
                                <p v-if="userType && userType === 'operator'">
                                    {{ company.operator_fee_percent > 0 ? Number(company.operator_fee_percent).toFixed(0) : '-' }}
                                </p>
                                <p v-else>
                                    {{ company.agent_fee_percent > 0 ? Number(company.agent_fee_percent).toFixed(0) : '-' }}
                                </p>
                            </a>
                            <a v-show="commissionsHidden"
                               @click="toggleCommissions"
                               class="color-black"
                               style="align-self: flex-start;"
                            >
                                <v-flex>
                                    Вернуть
                                </v-flex>
                            </a>
                        </v-flex>
                        <v-flex lg4 xs12 sm2 md2 class="antimite-list__data__item hidden-xs-only price-item">
                            <label>Цена, Р</label>
                            <p>
                                {{ company.premium > 0 ? Number(company.premium).toFixed(0) : '-' }}
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md12 class="antimite-list__data__more hidden-sm-and-down">
                            <div v-if="!company.showMore">
                                <a @click="showMore(company)">Подробнее о полисе</a>
                                <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                                    expand_less
                                </v-icon>
                            </div>
                            <div v-else>
                                <a @click="showLess(company)">Подробнее о полисе</a>
                                <v-icon class="material-symbols-outlined arrow-up-down">
                                    expand_less
                                </v-icon>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex sm6 class="layout align-center antimite-list__data__more hidden-md-and-up hidden-xs-only">
                    <div v-if="!company.showMore">
                        <a @click="showMore(company)">Подробнее о полисе</a>
                        <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                            expand_less
                        </v-icon>
                    </div>
                    <div v-else>
                        <a @click="showLess(company)">Подробнее о полисе</a>
                        <v-icon class="material-symbols-outlined arrow-up-down">
                            expand_less
                        </v-icon>
                    </div>
                </v-flex>
                <v-flex xs12 sm6 lg3 md3 layout column align-center class="antimite-list__button-block">
                    <v-btn
                        v-if="!isPayed"
                        class="button next-button block"
                        @click="isFormChanged ? '' : process(company)"
                        :loading="company.paymentLoading"
                        :disabled="isFormChanged"
                        :id="`button-pay-${company.company_alias}-${company.policy_type}`"
                    >
                        <v-content>
                            {{ isFormChanged ? 'Проведите перерасчет' : 'Оформить за ' + company.premium + ' Р' }}
                        </v-content>
                    </v-btn>
                    <v-btn
                        v-else
                        class="button next-button block"
                        disabled
                        id="button-payed"
                    >
                        <v-content>
                            {{ payedPremium == company.premium ? 'Оформлен за ' + company.premium + ' Р' : company.premium + ' Р' }}
                        </v-content>
                    </v-btn>
                </v-flex>

                <v-flex lg3 md3>
                </v-flex>
                <v-flex xs12 class="layout align-center justify-center antimite-list__data__more hidden-sm-and-up">
                    <div v-if="!company.showMore">
                        <a @click="showMore(company)">Подробнее о полисе</a>
                        <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": showMore }'>
                            expand_less
                        </v-icon>
                    </div>
                    <div v-else>
                        <a @click="showLess(company)">Подробнее о полисе</a>
                        <v-icon class="material-symbols-outlined arrow-up-down">
                            expand_less
                        </v-icon>
                    </div>
                </v-flex>
                <v-flex lg9 md9 sm12 xs12 class="antimite-list__data__info"
                        v-model="panel"
                >
                    <v-expansion-panel
                        v-model="company.panel"
                        expand
                    >
                        <v-expansion-panel-content
                            :key="'antimite-' + index"
                        >
                            <v-flex>
                                <br>
                                <p class="antimite-list__data__info__title">Условия</p>

                                <v-layout wrap row mb-4>
                                    <v-flex lg6 v-if="company.info">
                                        <p class="antimite-list__data__info__subtitle" v-if="company.info.risks && company.info.risks.length">Риски ДМС</p>
                                        <p class="antimite-list__data__info__subtext" v-if="company.info.risks && company.info.risks.length">
                                            <span v-for="(risk, index) in company.info.risks" :key="index">
                                                <span v-html="formatRisk(index, risk)"></span><br />
                                            </span>
                                        </p>

                                        <p class="antimite-list__data__info__subtitle" style="margin-top: 10px;" v-if="company.info.risks_ns && company.info.risks_ns.length">Риски НС</p>
                                        <p class="antimite-list__data__info__subtext" v-if="company.info.risks_ns && company.info.risks_ns.length">
                                            <span v-for="(risk, index) in company.info.risks_ns" :key="index">
                                                <span v-html="formatRisk(index, risk)"></span><br />
                                            </span>
                                        </p>
                                    </v-flex>

                                    <v-flex lg6 v-if="company.info && company.info.payments && company.info.payments.length">
                                        <p class="antimite-list__data__info__subtitle">Страховая сумма</p>
                                        <p class="antimite-list__data__info__subtext">
                                            <span v-for="(payment, index) in company.info.payments" :key="index">
                                                {{ payment }}<br />
                                            </span>
                                        </p>
                                    </v-flex>
                                </v-layout>

                                <v-layout wrap row>
                                    <v-layout row wrap class="antimite-list__data__info__docs">
                                        <v-flex lg12 md12 xs12>
                                            <p class="antimite-list__data__info__title"><span
                                                class="bold-text">Образцы документов</span></p>
                                        </v-flex>
                                        <v-flex lg4 md6 sm6 xs12>
                                            <a :href="'/docs/' + company.company_alias + '/' + company.policy_type + '/example.pdf'" target="_blank">
                                                Пример полиса
                                            </a>
                                        </v-flex>
                                        <v-flex lg4 md6 sm6 xs12>
                                            <a :href="'/docs/' + company.company_alias + '/kid.pdf'" target="_blank">
                                                КИД
                                            </a>
                                        </v-flex>
                                        <v-flex lg4 md6 sm6 xs12>
                                            <a :href="'/docs/' + company.company_alias + '/rules.pdf'" target="_blank">
                                                Правила страхования
                                            </a>
                                        </v-flex>
                                    </v-layout>
                                </v-layout>

                            </v-flex>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-flex>

            </v-layout>
        </v-content>

    </v-container>
</template>

<script>

export default {
    name: 'AntiMiteList',

    props: [
        'companiesList',
        'orderUuid',
        'isFormChanged',
        'isPayed',
        'payedPremium',
        'userType',
    ],

    data: () => ({
        showCommission: true,
        commissionsHidden: false,
        panel: false,
    }),

    methods: {
        toggleCommissions() {
            this.commissionsHidden = !this.commissionsHidden;
        },
        showMore(company) {
            company.showMore = true
            company.panel = ['0']
            this.panel = true
        },
        showLess(company) {
            company.showMore = false
            company.panel = []
            this.panel = false
        },
        process(company) {
            company.paymentLoading = true;
            if (typeof ym === 'function') {
                ym(100170943, 'reachGoal', 'sale_click_btn', {
                    order_price: company.premium,
                    currency: 'RUB',
                });
            }
            axios.get(`/antimite/${this.orderUuid}/process/${company.company_alias}/${company.policy_type}`)
                .then(response => {
                    if (response) {
                        console.log(response);
                        company.paymentLoading = false;
                        const paymentWindow = window.open(response.data.link, '_blank');

                        const timer = setInterval(function() {
                            if (paymentWindow && paymentWindow.closed) {
                                clearInterval(timer);
                                this.paymentLoading = false;
                            }
                        }, 1000);
                    }
                })
                .catch(error => {
                    console.log(error);
                    company.paymentLoading = false;
                })
                .finally(() => {
                    company.paymentLoading = false;
                });
        },
        formatRisk(index, risk) {
            return `${index + 1}. ${risk.replace(/\n/g, '<br>')}`;
        },
    }
}

</script>

<style scoped lang="scss">
.color-black {
    color: #000000;
}

.button {
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    width: 250px;
    height: 60px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 10px 20px 0 0;

    border-width: 1px;
    border-radius: 100px;
    border-style: solid;
}

.button >>> .v-btn__content {
    white-space: normal;
    line-height: 1.1;
}

.next-button {
    color: #ffffff !important;
    background-color: #00ba57 !important;
    border-color: transparent;
}

.button {
    width: 270px;
    height: 56px;
    max-width: 100%;
    font-size: 18px !important;
    @media(max-width: 960px) {
        font-size: 16px !important;

        width: 250px;
        height: 50px;
    }
    @media(max-width: 600px) {
        font-size: 18px !important;

        width: 100%;
        height: 70px;
    }
}

.antimite-list {
    &__logo {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            max-width: 226px;
            width: 100%;
            margin-bottom: 10px;
        }

        &__text {
            p {
                font-size: 14px;
            }
        }
    }

    &__data {
        &__more {
            // padding-top: 35px;
            padding-top: 20px;
            margin-bottom: 0;

            @media(max-width: 600px) {
                margin-bottom: 20px;
            }

            a {
                color: #000000;
                text-decoration: none;
                font-size: 16px !important;
                border-bottom: 1px solid #000000;

                &:hover, &:focus, &:active {
                    color: #000000;
                    text-decoration: none;
                }
            }

            .arrow-up-down {
                color: #000000;
                font-size: 20px;
                transition: transform .4s ease-in-out;
            }

            .rotate {
                transform: rotate(180deg);
            }
        }

        &__item {
            label {
                font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
                font-size: 16px;
                color: #828282;
            }

            p {
                font-family: 'SFProBold', 'Arial', 'sans-serif';
                font-size: 28px;
                font-weight: 700;
                margin: 0;
                white-space: nowrap;
                @media (max-width: 1280px) {
                    font-size: 24px;
                }
            }
        }

        &__info {
            /*p {
                font-size: 16px;
                line-height: 19px;
                font-family: 'SFUIDisplay', 'SFPro', serif;


                .black-text {
                    color: #000000;
                    white-space: normal;

                    &__sum {
                        white-space: pre;
                    }
                }

                .bold-text {
                    font-family: 'SFProBold', 'SFUIDisplay', serif;
                    color: #000000;
                    line-height: 19px;
                }
            }*/

            &__title {
                font-family: 'SFProBold', 'SFUIDisplay', serif;
                font-size: 16px;
                color: #000000;
                line-height: 25px !important;
                margin-bottom: 10px;
            }

            &__subtitle {
                font-size: 16px;
                color: #828282;
                line-height: 19px;
                margin-bottom: 0;
            }

            &__subtext {
                font-family: 'SFUIDisplay', 'SFPro', serif;
                font-size: 16px;
                line-height: 19px;
                color: #000000;
                max-width: 350px;
                margin-bottom: 0;
            }

            &__docs {
                border: 1px solid #E8E8E8;
                border-radius: 28px;
                padding: 30px 30px;
            }

            a {
                font-family: 'SFUIDisplay', 'SFPro', serif;
                color: #00BA57;
                text-decoration: none;
                font-size: 15px !important;
                border-bottom: 1px solid #00BA57;

                &:hover, &:focus, &:active {
                    color: #00BA57;
                    text-decoration: none;
                }
            }

            .v-expansion-panel {
                box-shadow: none;
            }
        }
    }

    &__button-block {
        text-align: center;
        @media(max-width: 600px) {
            padding-top: 20px;
        }

        a {
            font-family: 'SFUIDisplay', 'SFPro', serif;
        }

        .mortgage-list__data__more {
            text-align: center;
            padding-top: 25px;
        }

        .button {
            // width: 100%;
            margin-right: 0;
            max-width: 100%;
            font-family: 'SFUIDisplay', 'SFPro', serif;

            .v-btn__content {
                max-width: 100%;
            }
        }

        .v-expansion-panel {
            padding-top: 15px;
            box-shadow: none;
            a {
                font-size: 14px;
                margin-bottom: 10px;
                line-height: 28px;
            }
        }

        .black-text {
            color: #000000;
            white-space: pre;
        }
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/components/AntiMiteList.vue